"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitSubsidyBetweenTrips = splitSubsidyBetweenTrips;
function splitSubsidyBetweenTrips(orders, subsidyValue) {
    const sum = orders.reduce((acc, o) => acc + o.price, 0);
    let remaindingSubsidy = subsidyValue;
    const subsidies = orders.map((o, i) => {
        const part = o.price / sum;
        if (i === orders.length - 1) {
            return { subsidy: remaindingSubsidy, orderId: o._id };
        }
        const subsidy = Math.round(subsidyValue * part);
        remaindingSubsidy -= subsidy;
        return { subsidy, orderId: o._id };
    });
    return subsidies;
}
//# sourceMappingURL=splitSubsidyBetweenTrips.js.map